import { SxProps, Theme } from '@mui/material';

type NoArg = SxProps<Theme>;

interface MoveWishListItemMenuInterface {
	menuContainer: NoArg;
	createANewListItem: NoArg;
	viewListLink: NoArg;
	mobileDrawer: NoArg;
	title: NoArg;
	closeIcon: NoArg;
	createCardContainer: NoArg;
}

export const moveWishListItemMenu: MoveWishListItemMenuInterface = {
	menuContainer: {
		'& .MuiPaper-root': {
			width: '140px',
			borderRadius: 0,
		},
		'& .MuiMenuItem-root': {
			px: '5px',
		},
		' ul': {
			borderTop: '2px solid',
			borderTopColor: 'primary.main',
		},
	},
	createANewListItem: {
		'&:hover': {
			textDecoration: 'underline',
		},
	},
	viewListLink: {
		color: 'secondary.main',
		px: '20px',
		'&:hover': {
			textDecoration: 'underline',
		},
	},
	mobileDrawer: {
		zIndex: (theme) => `${theme.zIndex.tooltip + 1} !important`,
		'& .MuiDrawer-paper': {
			width: {
				xs: 320,
				sm: 320,
				md: 360,
				lg: 360,
				xl: 360,
			},
			padding: 0,
			overflowX: 'hidden',
		},
	},
	title: {
		py: '10px',
		position: 'sticky',
		top: 0,
		bgcolor: 'white',
		zIndex: 1,
		display: 'flex',
		justifyContent: 'center',
	},
	closeIcon: {
		position: 'absolute',
		top: 0,
		py: '10px',
		color: 'grey.100',
		border: 'none',
		boxShadow: 'none',
		'&:hover': {
			color: 'primary.main',
			border: 'none',
			boxShadow: 'none',
		},
		'&:focus': {
			outline: 'none',
		},
		right: 1,
	},
	createCardContainer: { boxShadow: 'none', padding: '0', alignItems: 'start' },
};
